import { AnalyticEventName } from './analytics';

export enum CrmQueue {
  CRM_ANALYTICS = 'crm-analytics',
}

export type SalesforceEventType = {
  WhoId?: string;
  WhatId?: string;
  Subject: string;
  Description: string;
  Status: string;
  Priority: string;
  ActivityDate: string;
};

export type HubspotEventType = {
  contactId: string;
  companyId: string;
  dealId: string;
  subject: string;
  description: string;
  timestamp: number;
  status: 'COMPLETED' | 'NOT_STARTED' | 'IN_PROGRESS';
  objectType: 'CONTACT' | 'COMPANY' | 'DEAL';
};

export enum FrontendPageAnalyticsEventNames {
  PAGE_SHARED = 'Page shared',
}

export type CrmAnalyticEventName =
  | AnalyticEventName
  | FrontendPageAnalyticsEventNames;

export type CrmEvent = {
  name: CrmAnalyticEventName;
  data: Record<string, unknown>;
  createdAt: Date;
};

export type AnalyticsEventsGroupedByPage = {
  [key: string]: CrmEvent[];
};
